/*
 * @Author: yanghailong
 * @Date: 2023-08-28 14:23:58
 * @Last Modified by: yanghailong
 * @Last Modified time: 2025-01-09 16:44:40
 */

import { GraphElement } from "../graph-element.js"
import { createFromJSON } from "./help.js"

class LoadElement extends GraphElement {
  static fromJSON = createFromJSON(this)
  constructor(topology, x, y, attrs) {
    super(topology, 'payload', x, y, {
      text: '负载',
      port: true,
      ...attrs
    })

    this.onLoad(() => {

      this.prop_y = 8

      this.addProperty('功率', 'kW')
      this.addProperty('无功功率', 'kvar')
      this.addProperty('视在功率', 'kVA')
    })
  }

  updateData(data) {
    this.updateProperty('功率', data.p)
    this.updateProperty('无功功率', data.q)
    this.updateProperty('视在功率', data.s)
  }

}



export { LoadElement }
